import Head from 'expo-router/head';
import * as AppConstants from '@/utilities/AppConstants';
import { BasicWrapperView } from '@/components/BasicWrapperView';
import { RabblsSearch } from '@/components/RabblsSearch';
import { CustomText } from '@/components/CustomText';
import { StyleSheet, View } from 'react-native';
import { useCallback } from 'react';
import { Community } from '@/types/community';
import { RelativePathString, useLocalSearchParams, useRouter } from 'expo-router';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  header: {
    padding: 10,
    alignItems: 'center',
  },
});

export default function NewCollab() {
  const router = useRouter();
  const { manage_community_id } = useLocalSearchParams<{ manage_community_id: string }>();

  const onPress = useCallback((community: Community) => {
    router.navigate(("/manage/" + manage_community_id + "/requestcollab?c=" + community.uniqueid) as RelativePathString);
  }, []);

  return (
    <BasicWrapperView center={false} style={AppConstants.STYLES.noHorizontalMargin}>
      <Meta title={"New collab"} />
      <View style={styles.header}>
        <CustomText>Collab with</CustomText>
      </View>
      <RabblsSearch
        extraUnusableHeight={50}
        onPress={onPress}
        skip_unique_ids={[manage_community_id]}
      />
    </BasicWrapperView>
  );
}
